import * as React from "react";
import DashboardRouter from "./DashboardRouter";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./account/Login";
import Logout from "./account/Logout";
import SelectLocation from "./account/SelectLocation";
import 'react-toastify/dist/ReactToastify.css';
import {UserProvider} from "./dashboard-components/UserContext";
import PhoneNumberChecker from "./dashboard-components/PhoneNumberChecker";
import { CallProvider } from "../lib/call-context";

export default function App() {
    return (
        <>
            <UserProvider>
                <PhoneNumberChecker/>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/select-location" element={<SelectLocation />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/dashboard/*" element={<CallProvider><DashboardRouter /></CallProvider>} />
                    </Routes>
                </BrowserRouter>
            </UserProvider>
        </>
    );
}